import React, { Component, Fragment } from 'react';

import EventTimeline from 'components/shared/EventTimeline';

import { CardText } from 'material-ui/Card';

import { groupedTableData } from 'helpers/tableHelpers';
import { isFilterInStrings } from 'helpers/StringHelper.js';
import { AccentColor } from 'helpers/AccentColorHelper';
import { deepDiver } from 'helpers/utilities';

import MaintenanceTicketsMobile from '../MaintenanceTicketsMobile';

import FooterButtons from 'components/shared/FooterButtons';

import AddAssetForm from './AddAssetForm';

import FlatButton from 'material-ui/FlatButton';

import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import { CSSTransitionGroup } from 'react-transition-group';
import Dialog from 'material-ui/Dialog';
import TextField from 'material-ui/TextField';

import { MdDelete as DeleteIcon } from 'react-icons/md';

import { assetStatus } from 'components/shared/MaintenanceStatuses';
import SubheaderText from 'components/shared/SubheaderText';

const pageViewHeaders = {
  DETAILS: 'details',
  WORKORDERS: 'workOrders',
  EVENTS: 'events',
};

const style = {
  transaction_card: {
    color: '#424242 !important',
    fontFamily: '"Circular", sans-serif !important',
    height: '100%',
    overflow: 'hidden',
    borderRadius: '8px',
  },
};

export default class MaintenanceAssetOverview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openView: pageViewHeaders.DETAILS,
      confirmationDialogOpen: false,
      typeFilter: '',
      filteredValue: '',
      maintenanceTickets: props.maintenanceAsset.maintenance_tickets,
    };
  }

  componentDidUpdate = (prevProps) => {
    if (
      this.props.maintenanceAsset.maintenance_tickets !==
      prevProps.maintenanceAsset.maintenance_tickets
    ) {
      this.setState({ maintenanceTickets: this.props.maintenanceAsset.maintenance_tickets });
    }
  };

  pageView = (pageToView) => {
    this.setState({
      openView: pageToView,
    });
  };

  toggleDialog = () => {
    this.setState({ confirmationDialogOpen: !this.state.confirmationDialogOpen });
  };

  deleteAsset = () => {
    this.props.deleteAction().then(() => {
      this.toggleDialog();
    });
  };

  getTypeFilterType = (e) => {
    this.setState({
      typeFilter: e.target.value,
      filteredValue: e.target.value,
      maintenanceTickets: this.filterTicketWithString(e.target.value),
    });
  };

  filterTicketWithString = (filterBy) => {
    return this.props.maintenanceAsset.maintenance_tickets.filter((item) =>
      isFilterInStrings(
        [
          item.status,
          item.unit_number,
          item.property_name,
          String(item.ticket_number),
          item.priority,
          item.request_type,
          item.subject,
        ],
        filterBy
      )
    );
  };

  render() {
    const { toggleDrawer } = this.props;

    return (
      <Fragment>
        <div
          className="row"
          style={{ width: '100%', height: '65px', padding: '10px', backgroundColor: 'white' }}
        >
          <h2 style={{ textAlign: 'center', margin: '8px 0' }}>
            Asset Details &nbsp;
            {assetStatus(this.props.maintenanceAsset.status, { fontSize: '41%' })}
          </h2>
        </div>
        {this.renderSubheader()}

        <div
          style={{
            padding: '15px',
            height: 'calc(100% - 155px)',
            overflow: 'scroll',
            backgroundColor: '#fbfbfb',
          }}
        >
          <CSSTransitionGroup
            transitionName="fade_out_buttons"
            transitionEnterTimeout={200}
            transitionLeaveTimeout={200}
          >
            {this.renderAssetDetails()}
            {this.renderTicketOverview()}
            {this.renderAssetHistory()}
          </CSSTransitionGroup>
        </div>
        <FooterButtons
          submit={this.submitForm}
          backName="Close"
          formName="edit_asset_form"
          submitName="Edit Asset"
          backAction={toggleDrawer}
        />
      </Fragment>
    );
  }

  renderAssetDetails = () => {
    if (this.state.openView !== pageViewHeaders.DETAILS) return;

    const actions = [
      <FlatButton label="Close" primary onClick={this.toggleDialog} />,
      <FlatButton label="Delete" primary keyboardFocused onClick={this.deleteAsset} />,
    ];

    return (
      <div className="row">
        {/************ Asset Information **************/}
        <h3 style={{ margin: '0 0 15px' }}>
          Overview
          <span style={{ float: 'right' }}>
            <DeleteIcon onClick={this.toggleDialog} size={24} style={{ padding: 0 }} />
            <Dialog
              title="Delete Asset?"
              actions={actions}
              modal={false}
              open={this.state.confirmationDialogOpen}
              onRequestClose={this.toggleDialog}
              contentStyle={{ maxWidth: '500px' }}
            >
              Are you sure you want to delete this asset? This cannot be undone.
            </Dialog>
          </span>
        </h3>

        <Card style={style.transaction_card}>
          <CardText expandable={true} style={{ padding: '0 0 10px' }}>
            <AddAssetForm
              onSubmit={(formData) => this.props.updateAsset(formData)}
              formName="edit_asset_form"
              initialValues={this.props.maintenanceAsset}
            />
          </CardText>
        </Card>
      </div>
    );
  };

  renderTicketOverview = () => {
    if (this.state.openView !== pageViewHeaders.WORKORDERS) return;

    return (
      <div className="row">
        <div className="row" style={{ marginTop: '5px' }}>
          <h3 style={{ margin: '0 0 15px', display: '-webkit-inline-box' }}> Work Orders </h3>
          <Button
            aria-haspopup="true"
            style={{
              margin: '-5px 0',
              backgroundColor: AccentColor(),
              color: 'white',
              fontSize: '13px',
              float: 'right',
              display: '-webkit-inline-box',
            }}
            onClick={this.props.toggleAddTicket}
          >
            Create Work Order
          </Button>
        </div>
        <div className="row">
          <TextField
            hintText="Filter by Unit, Property, Ticket #, Subject..."
            style={{ fontSize: '13px' }}
            value={this.state.typeFilter}
            onChange={this.getTypeFilterType}
          />
        </div>
        {/************ Work Order History **************/}
        <Card style={style.transaction_card}>
          <CardText style={{ padding: '0 15px', overflow: 'auto' }}>
            <MaintenanceTicketsMobile
              containerHeightOverride="100%"
              data={groupedTableData(this.state.maintenanceTickets)}
              goToTicket={this.props.toggleMaintenanceDrawer}
              updateMaintenenceTicket={this.props.updateTicket}
              bypassReactVirtualized
            />
          </CardText>
        </Card>
      </div>
    );
  };

  renderAssetHistory = () => {
    if (this.state.openView !== pageViewHeaders.EVENTS) return;

    return (
      <div className="row">
        <h3 style={{ margin: '0 0 15px' }}> History </h3>
        {/************ Asset Event History **************/}
        <Card style={style.transaction_card}>
          <CardText expandable={true} style={{ padding: '0 10px' }}>
            <EventTimeline events={deepDiver(this.props.maintenanceAsset, 'events')} />
          </CardText>
        </Card>
      </div>
    );
  };

  renderSubheader = () => (
    <div
      className="row"
      style={{ width: '100%', height: '29px', padding: '0 10px', backgroundColor: 'white' }}
    >
      <SubheaderText
        actionView={pageViewHeaders.DETAILS}
        subheaderText="Details"
        openView={this.state.openView}
        onClickAction={() => this.pageView(pageViewHeaders.DETAILS)}
      />
      <SubheaderText
        actionView={pageViewHeaders.WORKORDERS}
        subheaderText="Work Orders"
        openView={this.state.openView}
        onClickAction={() => this.pageView(pageViewHeaders.WORKORDERS)}
      />
      <SubheaderText
        actionView={pageViewHeaders.EVENTS}
        subheaderText="History"
        openView={this.state.openView}
        onClickAction={() => this.pageView(pageViewHeaders.EVENTS)}
      />
    </div>
  );
}
